import React, {useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import * as S from './SalesCampaignUI.styles';

// Component
import GIToggle from '../GIToggle/GIToggle';

interface SalesCampaignDataDataShape {
  titleText: string;
  titleTextColor: string;
  description: string;
  iconUrl: string;
  backgroundImage: string;
  subText?: string;
  title?: string;
  titleColor?: string;
}

interface SalesCampaignUIProps {
  customStyles?: any;
  toggleBtnHandler?: (isSelected?: boolean) => void;
  campaignData: SalesCampaignDataDataShape;
  isSaleHandlingFilterApplied?: boolean;
  isSeo?: boolean;
}

const SalesCampaignUI: React.FC<SalesCampaignUIProps> = ({
  customStyles = {},
  toggleBtnHandler,
  campaignData,
  isSaleHandlingFilterApplied = false,
  isSeo = false,
}) => {
  const [showShimmer, setShowShimmer] = useState<boolean>(false);
  const {
    iconUrl,
    backgroundImage,
    titleTextColor,
    titleText,
    description = '',
    title = '',
    subText = '',
    titleColor = '',
  } = campaignData;

  // Hide shimmer effect after 1.5 seconds
  useEffect(() => {
    if (isSeo) return;
    setShowShimmer(true);
    const timerId = setTimeout(() => setShowShimmer(false), 1500);
    return () => clearTimeout(timerId);
  }, []);

  const subTitle = description || subText;

  return (
    <S.SalesCampaignMainWrapper style={{...customStyles.Wrapper}}>
      <S.SalesCampaignWrapper>
        {/* Background image */}
        {!isSeo && (
          <S.SalesCampaignBackGroundImage
            src={backgroundImage}
            alt="backgroundImage"
            fetchPriority="high"
            loading="eager"
            decoding="async"
          />
        )}

        {/* Card content */}
        <S.CardWrapper
          $showShimmer={showShimmer}
          style={{...customStyles.CardWrapper}}
          $noBackground={!backgroundImage}
        >
          {!!iconUrl && (
            <S.MainImg src={iconUrl} style={{...customStyles.Image}} alt={`sales ${titleText}`} />
          )}
          <S.RightWrapper style={{...customStyles.TextWrapper}}>
            <S.Header
              className={toggleBtnHandler ? 'hasSwitch' : ''}
              color={titleTextColor || titleColor}
              style={{...customStyles.Header}}
            >
              {titleText || title}
            </S.Header>
            <S.DescWrapper>
              {!!subTitle && <S.Desc style={{...customStyles.SubHeader}}>{subTitle}</S.Desc>}
              {toggleBtnHandler && (
                <GIToggle
                  isEnabled={isSaleHandlingFilterApplied}
                  handleToggle={toggleBtnHandler}
                  enabledColor="#008CFF"
                  disabledColor="#E6E6E6"
                  id="toggle-btn-sales"
                />
              )}
            </S.DescWrapper>
          </S.RightWrapper>
        </S.CardWrapper>
      </S.SalesCampaignWrapper>
    </S.SalesCampaignMainWrapper>
  );
};

export default SalesCampaignUI;
